import { useContext } from "react";
import { Box, Button, Typography } from "@mui/material";
import LoadingWheel from "../../../../common/LoadingWheel";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import { green, purple, text } from "../../../../../theme/colours";

const StatDisplay = ({
  width,
  name,
  value,
  personalValue,
  compDesc,
  compValue,
  tips,
  loading,
  main,
  colour,
}) => {
  const { t } = useTranslation("Stats");
  const { mobileView, tabletView, desktopView, setOptionState } =
    useContext(GlobalContext);
  const isSpecial = !desktopView && main;

  const statBox = {
    width: width ?? "100%",
    height: desktopView || main ? "100%" : "50%",
    display: "flex",
    flexDirection: "column",
    ...(!main &&
      !desktopView && {
        "&:nth-child(odd)": {
          borderRight: `1px solid ${colour}`,
        },
      }),
  };
  const contentBox = {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    pt: !desktopView && "5%",
    ...(isSpecial && {
      p: "10% 0",
    }),
  };
  const nameText = {
    fontWeight: desktopView ? 800 : 700,
    textAlign: "center",
    textTransform: "capitalize",
    pt: "3%",
    ...(!desktopView && {
      fontSize: "1.25rem",
    }),
  };
  const loadBox = {
    height: mobileView ? "3rem" : tabletView ? "5rem" : "2.5rem",
  };
  const valueStyle = {
    m: desktopView ? "10% 0 5%" : "5% 0 2.5%",
    textAlign: "center",
    ...(!desktopView && {
      fontSize: "2.5rem",
    }),
  };
  const personalText = {
    textAlign: "center",
    fontSize: "0.875rem",
  };
  const compText = {
    py: "0.75rem",
    m: 0,
    color: desktopView && purple[1],
    textAlign: "center",
    fontWeight: 500,
  };
  const compBox = {
    width: "100%",
    backgroundColor: isSpecial ? colour : purple[4],
  };
  const tipButton = {
    position: desktopView ? "absolute" : "static",
    bottom: "2.25rem",
    width: desktopView ? width : "100%",
    textTransform: "capitalize",
    color: desktopView ? green[2] : text.primary,
    padding: "10px 8px",
    height: "fit-content",
    fontSize: "0.875rem",
    fontWeight: 700,
    mt: 0,
    ...(isSpecial && {
      position: "absolute",
      width: "auto",
      transform: "translate(-50%)",
      left: "-52.5%",
      bottom: "7.5%",
    }),
  };

  const handleTipClick = () => {
    setOptionState({
      nav: "levelUp",
      page: "display",
      selSubCat: name,
    });
  };

  return (
    <Box sx={statBox}>
      <Box sx={contentBox}>
        <Typography sx={nameText}>{name}</Typography>
        {loading ? (
          <Box sx={loadBox}>
            <LoadingWheel width={2} />
          </Box>
        ) : (
          <Typography sx={valueStyle} variant="h1">
            {value || "-"}
          </Typography>
        )}
        {compDesc === "Team" && (
          <Box>
            <Typography sx={personalText}>{`You: ${personalValue}`}</Typography>
          </Box>
        )}
        {tips && (
          <Button sx={tipButton} onClick={handleTipClick}>
            {`${t("seeTips")} →`}
          </Button>
        )}
      </Box>
      <Box sx={compBox}>
        <Typography sx={compText}>{`${compDesc}: ${compValue}`}</Typography>
      </Box>
    </Box>
  );
};

export default StatDisplay;
